import { ActionTree, GetterTree, MutationTree } from 'vuex'
import { State as Root } from '.'
import alicloudapi from '@/http/alicloudapi'
import axios from 'axios'

export interface RankItem {
  orderCount: number
  percent: number
  personCount: number
  teamName: string
  totalAmount: number
}

export interface State {
  loading: boolean
  configUrl: string
  config: object | null
  startDate: string
  endDate: string
  rankList: RankItem[]
}

export const state: Action<State> = () => ({
  loading: false,
  configUrl: 'https://cdn.xiaobaoxiu.cn/xbshow/moonglow/rank/config.json',
  config: null,
  startDate: '',
  endDate: '',
  rankList: []
})

export const getters: GetterTree<State, Root> = {
  formatDate: state => `${state.startDate}-${state.endDate}`
}

export const mutations: MutationTree<State> = {
  setData(state, { startDate, endDate, rankList }) {
    state.startDate = startDate
    state.endDate = endDate
    state.rankList = rankList
  },
  setConfig(state, config: object) {
    state.config = config
  },
  setLoading(state, loading: boolean) {
    state.loading = loading
  }
}

export const actions: ActionTree<State, Root> = {
  async fetch({ state, commit }) {
    commit('setLoading', true)
    const configRes: any = await axios.get(state.configUrl, {
      params: {
        ver: Date.now()
      }
    })
    commit('setConfig', configRes.data)
    const res: any = await alicloudapi.post(
      '/performance_statistic/ad_statistic?appCode=8ec55b42baf6405194ee646132a29958&pageNum=1&pageSize=100'
    )
    commit('setData', {
      startDate:
        res.rows && res.rows.length ? res.rows[0].begindate : '2020年11月17日',
      endDate:
        res.rows && res.rows.length ? res.rows[0].enddate : '2020年11月30日',
      rankList: res.rows
        ? res.rows.map(item => {
            return {
              orderCount: item.order_cnt,
              percent: item.comp_rate,
              personCount: item.user_cnt,
              teamName: item.department,
              totalAmount: item.amount
            }
          })
        : []
    })
    commit('setLoading', false)
  }
}

export const namespaced = true
